import { ICONS_NAME } from './icons.constants';

export const BTN_PRIMARY_LG = {
    class: 'q-btn-lg q-btn-primary text-body1',
    color: 'primary',
    noCaps: true,
    textColor: 'white'
};

export const BTN_PRIMARY_MD = {
    class: 'q-btn-md q-btn-primary text-body2',
    color: 'primary',
    noCaps: true,
    textColor: 'white'
};

export const BTN_PRIMARY_SM = {
    class: 'q-btn-sm q-btn-primary text-body2',
    color: 'primary',
    noCaps: true,
    textColor: 'white'
};

export const BTN_SECONDARY_LG = {
    class: 'q-btn-lg q-btn-secondary text-body1',
    color: 'white',
    noCaps: true,
    textColor: 'grey-dark'
};

export const BTN_SECONDARY_MD = {
    class: 'q-btn-md q-btn-secondary text-body2',
    color: 'white',
    noCaps: true,
    textColor: 'grey-dark'
};

export const BTN_SECONDARY_SM = {
    class: 'q-btn-sm q-btn-secondary text-body2',
    color: 'white',
    noCaps: true,
    textColor: 'grey-dark'
};

export const BTN_NEGATIVE_LG = {
    class: 'q-btn-lg q-btn-negative text-body1',
    color: 'negative',
    noCaps: true,
    textColor: 'white'
};

export const BTN_NEGATIVE_MD = {
    class: 'q-btn-md q-btn-negative text-body2',
    color: 'negative',
    noCaps: true,
    textColor: 'white'
};

export const BTN_NEGATIVE_SM = {
    class: 'q-btn-sm q-btn-negative text-body2',
    color: 'negative',
    noCaps: true,
    textColor: 'white'
};

export const BTN_NEGATIVE_SECONDARY_LG = {
    class: 'q-btn-lg q-btn-negative-secondary text-body1',
    color: 'white',
    noCaps: true,
    textColor: 'negative'
};

export const BTN_NEGATIVE_SECONDARY_MD = {
    class: 'q-btn-md q-btn-negative-secondary text-body2',
    color: 'white',
    noCaps: true,
    textColor: 'negative'
};

export const BTN_NEGATIVE_SECONDARY_SM = {
    class: 'q-btn-sm q-btn-negative-secondary text-body2',
    color: 'white',
    noCaps: true,
    textColor: 'negative'
};
export const BTN_TERTIARY_NEGATIVE_SECONDARY_SM = {
    class: 'q-btn-sm q-btn-negative-tertiary text-body2',
    noCaps: true,
    textColor: 'negative'
};

export const BTN_TERTIARY_LG = {
    class: 'q-btn-lg q-btn-tertiary text-body1',
    noCaps: true,
    textColor: 'grey-dark'
};

export const BTN_TERTIARY_MD = {
    class: 'q-btn-md q-btn-tertiary text-body2',
    noCaps: true,
    textColor: 'grey-dark'
};

export const BTN_TERTIARY_SM = {
    class: 'q-btn-sm q-btn-tertiary text-body2',
    noCaps: true,
    textColor: 'grey-dark'
};

export const BTN_TERTIARY_XS = {
    class: 'q-btn-sm q-btn-xs q-btn-tertiary text-body2',
    noCaps: true,
    textColor: 'grey-dark'
};

export const BTN_DROPDOWN_SM = {
    class: 'text-grey-dark text-body2 q-btn-sm q-btn-secondary',
    color: 'white',
    menuAnchor: 'bottom start',
    menuSelf: 'top start',
    menuOffset: [0, 8],
    dropdownIcon: ICONS_NAME.CHEVRON_DOWN_SOLID,
    style: 'max-width: 100%',
    noCaps: true
};

export const BTN_DROPDOWN_MD = {
    class: 'text-grey-dark text-body2 q-btn-md q-btn-secondary',
    color: 'white',
    menuAnchor: 'bottom start',
    menuSelf: 'top start',
    menuOffset: [0, 8],
    dropdownIcon: ICONS_NAME.CHEVRON_DOWN_SOLID,
    style: 'max-width: 100%',
    noCaps: true
};

export const BTN_DROPDOWN_PRIMARY_MD = {
    class: 'text-body2 q-btn-md q-btn-primary',
    color: 'primary',
    textColor: 'white',
    menuAnchor: 'bottom start',
    menuSelf: 'top start',
    menuOffset: [0, 8],
    dropdownIcon: ICONS_NAME.CHEVRON_DOWN_SOLID,
    style: 'max-width: 100%',
    noCaps: true
};
